/* eslint-disable jsx-a11y/anchor-is-valid */
import Aside from "../../components/Sidebar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollUp from "../../components/ScrollUp";
import MainTitle from "../../components/MainTitle";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Articles = () => {
  return (
    <>
      <div className="page d-flex">
        <Aside />
        <div className="content w-full">
          <Header />
          <MainTitle title="المقالات" />
          <div
            className="container-8"
            style={{
              paddingBottom: "60px",
            }}
          >
            <div className="wb-1 m-wb bg-white p-10 m-10">
              <div className="inf inf-2">
                <h3 className="my-h3-2 my-h3">Array Method-2</h3>
              </div>
            </div>
            <pre class="my-pre">
              {" "}
              اهلا يا صديقي. هنكمل النهارده عن ال Array Methodes أنت لازم تشوف
              البوست الي فات الأول لانه تكمله ليه هتلاقي الينك في أول كومنت💙
              متنساش تعمل لايك وتتابعني لو أستفدت💙
              ========================================== 1- sort بترتب ال Array
              بتاعتنا والصراحه لو شرحتها هنا هتتوه ومش هتفهم فا هسيبلك لينك
              الفيديو بيشرح الموجود في المقاله في اول كومنت لو انت مبتدئ انما ده
              بيعتبر ملخص للمراجعه. ===========================================
              2- indexOf بتقبل قيميتين الاولى هي مكان العنصر الي هتبحث عنه
              والتانيه هي المكان الي هتبدأ من عنده القيمه الاولى اجباريه
              والتانيه اختياري بس لو مكتبتش المكان فا هيبدأ يبحث من الصفر
              =========================================== 2- last Index OF دي
              شبه الي فوق ولكن دي بتبحث من الاخر اما الي فوق بتبحث من الاول
              =========================================== 3- includes بتعمل فحص
              وبتشوف هل العنصر الي انت مديه ليها موجود فالArray ولا لاء وبتطلب
              منك قيمتين برضه نفس الي فوق وبترجع true لو العنصر موجود وبترجع
              False لو مش موجود ودي غالبا بتستخدم في شروط if
              =========================================== 4- slice دي بتقطع
              الجزء الي انت بتحدده من ال Array بتقبل قيميتين الاولى الي هتبدأ
              منها والتانيه الي هتنتهي عندها والاتنين اختيارين بس لومكتبتش
              الاتنين هيعمل slicing لل Array كلها ولو مكتبتش البدايه هياخد من
              صفر ولو مكتبتش النهايه هياخد للاخر وبترجع الناتج في Array جديده بس
              خد بالك هي مش بتاخد اخر عنصر انت كتبته هي بتاخد الي قبله فالازم
              تاخد بالك من النقطه دي ===========================================
              5 - splice دي بتضيف او بتحذف للArray بس بتعدل عليها مبترجعش Array
              جديده وبتطلب من تلات حاجات الاولى هي البدايه ودي اجباري اما الباقى
              على حسب انت هتعمل ايه تاني حاجه هي عدد العناصر الي انت عاوز تحذفها
              من ال Array تالت حاجه بتكتب العناصر الي انت عاوز تضيفها
              =========================================== 6 - concat بتعمل
              concat لاكتر من Array مع بعض وبيرجعو في Array جديده وبتطلب منك
              أسماء الArray الي هتعملهم concat مع بعض وممكن تضيف عنصر لوحده
              وممكن تضيف Array جوا Array
              =========================================== 7 - Join بتعمل joining
              لعناصر Array وبتطلعلك String فيه العناصر دي مفصولين بسيباريتور انت
              الي بتحدده (مرضتش اكتبها انجليزي عشان تقرأها اسرع اعمل لايك
              بقا😂🤓) ولو مضفتش سيباريتور هيحط فاصله , لو حطيت فالسيباريتور
              علامه " " هيرجعهم من غير فواصل ولازقين في بعض
              =========================================== 8 - toString بتحول ال
              Array ل String (نصوص يعني). بس كده.....متنساش تعمل لايك عشان
              البوست يوصل لغيرك وتتابعني عشان الجديد💙 اشوفك بكره......سلام💙
              <a
                href="https://web.facebook.com/hashtag/%D8%AA%D8%B9%D9%84%D9%85_%D9%85%D9%86_%D8%A7%D8%AC%D9%84%D9%83"
                class="m-a"
              >
                #تعلم_من_اجلك
              </a>
            </pre>
          </div>
          <ScrollUp />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Articles;
